<template>
  <div></div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'LoginAsClient',
  data() {
    return {
      form: {
        program: '',
        hash: '',
      },
    };
  },
  beforeCreate: function () {
    document.body.className = 'login';
  },
  beforeMount() {
    this.form.program = this.$route.params.program;
    this.form.hash = this.$route.params.hash;
    this.login();
  },
  methods: {
    ...mapActions({
      signIn: 'auth/signIn',
    }),

    async login() {
      try {
        if (this.$route.params.staffName) {
          localStorage.setItem('staffName', this.$route.params.staffName);
        }

        if (this.$route.params.id) {
          localStorage.setItem('staffId', this.$route.params.id);
        }

        await this.signIn(this.form);

        this.$router.push({
          name: 'Licence',
          params: { program: this.form.program },
        });
      } catch (error) {
        this.$router.push({
          name: 'Login',
          params: { program: this.form.program },
        });
      }
    },
  },
};
</script>

<style scoped></style>
